/**
 * 디바이스 정보 유틸리티
 * - Flutter 앱에서 WebView로 주입된 디바이스 정보를 관리
 * - 로그인 시 백엔드에 모바일 확정 판별 및 device_model/os_type 저장용으로 사용
 */

const DEVICE_INFO_KEY = 'deviceInfo';

/**
 * 디바이스 정보 가져오기
 * - Flutter 앱에서 localStorage에 저장한 디바이스 정보를 반환
 * @returns {{ deviceId?: string, deviceModel?: string, osType?: string } | null}
 */
export function getDeviceInfo() {
  try {
    const raw = localStorage.getItem(DEVICE_INFO_KEY);
    if (raw == null || raw === '') return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return {
        deviceId: parsed.deviceId ?? null,
        deviceModel: parsed.deviceModel ?? null,
        osType: parsed.osType ?? null,
      };
    }
    return null;
  } catch (e) {
    return null;
  }
}

/**
 * 디바이스 정보 저장 (Flutter에서 호출 시 사용, 내부 저장용)
 * @param {Object} info - { deviceId?, deviceModel?, osType? }
 */
export function setDeviceInfo(info) {
  try {
    if (info && typeof info === 'object') {
      localStorage.setItem(DEVICE_INFO_KEY, JSON.stringify(info));
    }
  } catch (e) {
    // 저장 실패 시 특별한 처리 없음
  }
}

/**
 * 디바이스 정보 삭제 (로그아웃 시 Flutter clearLocalStorage와 함께 정리됨)
 */
export function removeDeviceInfo() {
  try {
    localStorage.removeItem(DEVICE_INFO_KEY);
  } catch (e) {
    // 무시
  }
}

// Flutter에서 호출할 전역 콜백 함수 등록
if (typeof window !== 'undefined') {
  window.onDeviceInfoReceived = (info) => {
    if (info && typeof info === 'object') {
      setDeviceInfo(info);
      window.dispatchEvent(new CustomEvent('deviceInfoReceived', { detail: { info } }));
    }
  };
}
